import React from "react";
import { MessageOverlay } from "../Components/MessageOverlay/MessageOverlay";

export const withMessageOverlay = (title: string, message: string) => (WrappedComponent) => (props) => {
  const {
    socketReducer: {
      isInTimeout = false,
    } = {},
  } = props;

  return isInTimeout ? (<>
    <WrappedComponent {...props} />
    <MessageOverlay title={title} message={message} />
  </>) : <WrappedComponent {...props} />;
};
